import { g, layers } from '@hcie/core';
import { EventBus } from '@hcie/shared';

type NamedDrawAction = {
    description: string;
    undo: () => void;
    redo: () => void;
};

export function makeNamedDrawAction(layerIndex: number, prev: ImageData, next: ImageData, desc: string): NamedDrawAction {
    // Note: We clone buffers to keep history immutable.
    const prevCopy = new ImageData(new Uint8ClampedArray(prev.data), prev.width, prev.height);
    const nextCopy = new ImageData(new Uint8ClampedArray(next.data), next.width, next.height);

    const apply = (img: ImageData, mode: string) => {
        // Use global layers list to ensure we target the correct reference after structural changes
        const globalLayers = (window as any).layers || layers;
        const targetLayer = globalLayers[layerIndex];
        
        if (!targetLayer || !targetLayer.ctx) {
            console.error(`[History] Apply FAILED: Layer at index ${layerIndex} or its context is missing.`);
            return;
        }

        targetLayer.ctx.putImageData(img, 0, 0);
        
        // Sync both the canvas visuals and the UI panels
        EventBus.emit('RENDER_LAYERS');
        EventBus.emit('UPDATE_LAYER_PANEL');
    };

    return {
        description: desc,
        undo: () => apply(prevCopy, 'UNDO'),
        redo: () => apply(nextCopy, 'REDO'),
    };
}

export function makeNamedVectorAction(layerIndex: number, prevShapes: any[], nextShapes: any[], desc: string): NamedDrawAction {
    const prevCopy = JSON.parse(JSON.stringify(prevShapes || []));
    const nextCopy = JSON.parse(JSON.stringify(nextShapes || []));

    const apply = (shapes: any[]) => {
        const globalLayers = (window as any).layers || layers;
        const targetLayer = globalLayers[layerIndex];
        if (targetLayer) {
            targetLayer.shapes = JSON.parse(JSON.stringify(shapes));
            EventBus.emit('RENDER_LAYERS');
            EventBus.emit('UPDATE_LAYER_PANEL');
        }
    };

    return {
        description: desc,
        undo: () => apply(prevCopy),
        redo: () => apply(nextCopy),
    };
}

export function bindDrawActionToWindow() {
    // Provide legacy global for canvas-ui FinishHandler.
    (window as any).makeNamedDrawAction = makeNamedDrawAction;
    (window as any).makeNamedVectorAction = makeNamedVectorAction;
}

